export interface InventoryAdjustmentRow {
  id: string
  code: string
  reference: string
  warehouse: string
}

/** Start empty like live table with no API */
export const INITIAL_MOCK_ADJUSTMENTS: InventoryAdjustmentRow[] = []

export interface AdjustmentLine {
  id: string
  itemId: string
  batchId: string
  currentQty: number
  newQty: number
}

export function newAdjustmentLine(): AdjustmentLine {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    itemId: '',
    batchId: '',
    currentQty: 0,
    newQty: 0,
  }
}

export function quantityAdjusted(line: AdjustmentLine): number {
  return (Number(line.newQty) || 0) - (Number(line.currentQty) || 0)
}
